import PlansHero from './plans-hero'

export default PlansHero
